module.exports = __webpack_public_path__ + "img/frame.8cb43805.svg";